// @file utilities for vote/rating/score field responses
import type { RespondableFieldValue } from '../types'

// Computes optimistic vote/rating/score field state when user creates, changes, or deletes their response.
export const applyResponseToFieldValue = (
  oldFieldValue: RespondableFieldValue | undefined,
  value: number | undefined,
) => {
  // Optimistically update the post's custom properties
  const oldUserResponse = oldFieldValue?.user_response
  const oldSum = oldFieldValue?.sum ?? 0
  const oldCount = oldFieldValue?.count ?? 0

  let newSum = oldSum
  let newCount = oldCount

  if (oldUserResponse != null && value == null) {
    // User deleting their response
    newSum = oldSum - oldUserResponse
    newCount = oldCount - 1
  } else if (oldUserResponse != null && value != null) {
    // User changing their response
    newSum = oldSum - oldUserResponse + value
    newCount = oldCount
  } else if (oldUserResponse == null && value != null) {
    // User creating a new response
    newSum = oldSum + value
    newCount = oldCount + 1
  }

  return {
    sum: newSum,
    count: newCount,
    user_response: value,
  }
}
